import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getHCEmailPDF, rspHCEmailPDF, LastSentPDF } from "../../utils/GetAdmin";
import { sendAllPDFs, sendPDF, respSendPDF } from "../../utils/PostAdmin";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import {formatDateTime} from "../../utils/Formatter";
import { GetStatusBadge } from "../../components/request/requestUtils";
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    button: {
      marginLeft: theme.spacing(2),
      minWidth: 150,
    },
  })
);
export default function ISupHCEmailPDF() {
  const classes = useStyles();
  const [hcEmailPDF, setHCEmailPDF] = useState<rspHCEmailPDF|undefined>();
  const [rsltSendPDF, setRsltSendPDF] = useState<respSendPDF|undefined>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});
  const [codes, setCodes] = React.useState<any>();
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:150;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  
  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES","vp_req_status"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        getHCEmailPDF(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v){
            setHCEmailPDF(v);
          }
        });
      });
      
  }, [hcEmailPDF, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && hcEmailPDF && enabled? (
        <div>
              <TableAbstraction
                settingsKey="ADM_IS_HC_PDF_SUM"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  tableBodyHeight: "400px",
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                }}
                title="PDF Email Health Check (All Bottlers)"
                columns={[
                  {
                    label: "Client Id",
                    name: "clientId",
                    options: {
                      searchable: false,
                      filter: false,
                    },
                  },
                  {
                    label: "Sales Org",
                    name: "salesOrg",
                    options: {
                      searchable: false,
                      filter: true,
                    },
                  },
                  {
                    label: "Last PDF Email Date",
                    name: "lastPdfEmailDt",
                    options: {
                      searchable: false,
                      filter: true,
                      customBodyRender: (value)=> {return formatDateTime(value,'')}
                    },
                  },
                  {
                    label: "PDF Pending Sending",
                    name: "pendingCount",
                    options: {
                      searchable: false,
                      filter: false,
                    },
                  },
                  {
                    label: "PDF Grouping",
                    name: "pdfGrouping",
                    options: {
                      searchable: true,
                      filter: false,
                    },
                  },
                  {
                    label: "Trigger Emails",
                    name: "sendPDFs",
                    options: {
                      searchable: true,
                      filter: false,
                      renderCell: (params) => {
                        const salesOrg:string = params.row.salesOrg; 
                        const pendingCount:number = params.row.pendingCount; 
                        if(pendingCount < 1) return '';
                        return (
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.button}
                            onClick={()=>{
                              sendAllPDFs(salesOrg).then(rsp=>{
                                setRsltSendPDF(rsp.data);
                              })
                            }}
                          >
                            <AttachEmailIcon /> Send Pending
                          </Button>
                        )
                      } ,
                    },
                  },
                ]}
                data={hcEmailPDF.lastSent}
              />
              
              <TableAbstraction
                settingsKey="ADM_IS_HC_PDF_PND"
                options={{
                  draggableColumns: {
                    enabled: true,
                  },
                  rowsPerPageOptions: [25, 50, 100],
                  tableBodyHeight: "400px",
                  serverSide: false,
                  selectableRows: "none",
                  rowsPerPage: muiTable.rpp,
                  onChangeRowsPerPage: (numberOfRows) => {
                    muiTable.rpp = numberOfRows;
                    setMuiTable(muiTable);
                  },
                }}
                title={`Pending PDF Emails (${salesOrg} Only)`}
                columns={[
                  
                  {
                    label: "Send Email",
                    name: "sendPDFs",
                    options: {
                      searchable: true,
                      filter: false,
                      renderCell: (params) => {
                        const requestNum:number = params.row.requestNum; 
                        return (
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.button}
                            onClick={()=>{
                              sendPDF(salesOrg,requestNum).then(rsp=>{
                                setRsltSendPDF(rsp.data);
                              })
                            }}
                          >
                            <AttachEmailIcon /> Send
                          </Button>
                        )
                      } ,
                    },
                  },
                  {
                    label: "Request Num",
                    name: "requestNum",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "SAP Num",
                    name: "sapRequestNumber",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "Request Date",
                    name: "requestedDt",
                    options: {
                      searchable: true,
                      filter: false,
                      customBodyRender: (value: any) => {return `${value?formatDateTime(value):""}`} ,
                    },
                  },
                  {
                    label: "Status",
                    name: "requestStatus",
                    options: {
                      searchable: true,
                      filter: false,
                      customBodyRender: (value: any) =>  (<GetStatusBadge status={value} codes={codes} />),
                    },
                  },
                  {
                    label: "Requested By",
                    name: "requestedBy",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "Customer",
                    name: "customerNum",
                    options: {
                      searchable: true,
                      filter: true,
                    },
                  },
                  {
                    label: "Customer Name",
                    name: "customerName1",
                    options: {
                      searchable: true,
                      filter: true,
                      renderCell: (params) => {
                        const name1 = params.row.mdCustomer.name1; 
                        return name1;
                      } ,
                    },
                  },
                  {
                    label: "Sales Office",
                    name: "salesOffice",
                    options: {
                      filter: true,
                      renderCell: (params) => {
                        const salesOffice = params.row.mdCustomer.salesOffice; 
                        return `${salesOffice || '?'} - ${determineConfig(codes, "SALESOFFICES", salesOffice || '?')}`
                      } ,
                    }
                  },
                  {
                    label: "Opt Type",
                    name: "optimizationType",
                    options: {
                      searchable: true,
                      filter: false,
                    },
                  },
                  {
                    label: "Last Change",
                    name: "lastChangeDt",
                    options: {
                      searchable: true,
                      filter: false,
                    },
                  }
                ]}
                data={hcEmailPDF.pending}
              />
          <Dialog
              open={rsltSendPDF?true:false}
              onClose={()=>setRsltSendPDF(undefined)}
            >
              <DialogTitle>Attempting to build PDF emails </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {rsltSendPDF?.message}
                </DialogContentText>
                <DialogContentText>
                  Sales Offices: {rsltSendPDF?.salesOffices?.join(', ')}
                </DialogContentText>
                <DialogContentText>
                  Customers: {rsltSendPDF?.customers?.join(', ')}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={()=>setRsltSendPDF(undefined)} color="primary">
                  Okay
                </Button>
              </DialogActions>
          </Dialog>
        </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}